const DIGITS = ["không", "một", "hai", "ba", "bốn", "năm", "sáu", "bảy", "tám", "chín"];
const GROUPS = ["", "nghìn", "triệu", "tỷ", "nghìn tỷ", "triệu tỷ"];

function readTriple(value: number, full = false) {
  const hundred = Math.floor(value / 100);
  const ten = Math.floor((value % 100) / 10);
  const unit = value % 10;
  const words: string[] = [];
  if (hundred > 0 || full) words.push(DIGITS[hundred], "trăm");
  if (ten > 1) {
    words.push(DIGITS[ten], "mươi");
    if (unit === 1) words.push("mốt");
    else if (unit === 4) words.push("tư");
    else if (unit === 5) words.push("lăm");
    else if (unit > 0) words.push(DIGITS[unit]);
  } else if (ten === 1) {
    words.push("mười");
    if (unit === 5) words.push("lăm");
    else if (unit > 0) words.push(DIGITS[unit]);
  } else if (unit > 0) {
    if (hundred > 0 || full) words.push("lẻ");
    words.push(DIGITS[unit]);
  }
  return words.join(" ");
}

export function numberInVietnameseWords(amount: number) {
  const integer = Math.floor(Math.abs(Number(amount) || 0));
  if (integer === 0) return "Không";
  const chunks: number[] = [];
  let remaining = integer;
  while (remaining > 0) {
    chunks.push(remaining % 1000);
    remaining = Math.floor(remaining / 1000);
  }
  const words: string[] = [];
  for (let index = chunks.length - 1; index >= 0; index -= 1) {
    const chunk = chunks[index];
    if (!chunk) continue;
    const full = index < chunks.length - 1 && chunk < 100;
    words.push(readTriple(chunk, full));
    if (GROUPS[index]) words.push(GROUPS[index]);
  }
  const text = words.join(" ").replace(/\s+/g, " ").trim();
  return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
}

export function moneyInVietnameseWords(amount: number) {
  return `${numberInVietnameseWords(amount)} đồng chẵn.`;
}
